import { Dispatch } from "redux";
import {
  getLeadListByInstituteAndContact,
  setLeadModalState,
} from "../../../pages/app/Nurture/service/nurtureSlice";

function leadPopupApiCall(
  instituteId: string,
  phone: string | null,
  email: string | null,
  dispatch: Dispatch
) {
  if (!instituteId) return;
  let data: any;
  if (phone) {
    data = { id: instituteId, phone };
    dispatch<any>(getLeadListByInstituteAndContact(data));
  } else if (email) {
    data = { id: instituteId, email };
    dispatch<any>(getLeadListByInstituteAndContact(data));
  }
}

export function openLeadExpandModal(
  instituteId: string,
  phone: string,
  email: string,
  id: string,
  dispatch: Dispatch,
  leadTab: string,
  taskId?: string,
  taskTab?: string,
  emiId?: string,
  addLeadParam?: boolean
) {
  if (instituteId && id) {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("leadModal", "true");
    queryParams.set("leadInstituteId", instituteId);
    queryParams.set("leadId", id);

    if (leadTab) {
      queryParams.set("tabOpen", leadTab);
    } else {
      queryParams.set("tabOpen", "overview");
    }

    if (email) {
      queryParams.set("leadEmail", email);
    } else {
      queryParams.delete("leadEmail");
    }

    if (phone) {
      queryParams.set("leadPhone", phone);
    } else {
      queryParams.delete("leadPhone");
    }

    if (taskId) {
      queryParams.set("leadTaskId", taskId);
    }

    if (taskTab) {
      queryParams.set("taskTabOpen", taskTab);
    }
    if (emiId) {
      queryParams.set("leadEmiId", emiId);
    }

    if (addLeadParam) {
      queryParams.set("addLeadPayment", "true");
    }

    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);

    dispatch(setLeadModalState());

    if (instituteId && (phone || email)) {
      leadPopupApiCall(instituteId, phone, email, dispatch);
    }
  } else {
    return;
  }
}
